import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { DeviceImageRecord } from '@/domains/deviceImages/types/deviceImagesType';

export const useDeviceImageStore = defineStore('devicesImages', () => {
  const offlineQueue = ref<DeviceImageRecord[]>([]);

  const addToOfflineQueue = (image: DeviceImageRecord) => {
    offlineQueue.value.push(image);
  };

  const removeFromOfflineQueue = (imageId: number) => {
    offlineQueue.value = offlineQueue.value.filter((image) => image.id !== imageId);
  };

  const clearOfflineQueue = () => {
    offlineQueue.value = [];
  };

  return {
    offlineQueue,
    addToOfflineQueue,
    removeFromOfflineQueue,
    clearOfflineQueue,
  };
});
